// Mock data for the website
export const recipes = [
  {
    id: 13,
    title: "Strawberry Cheesecake",
    description: "A creamy baked cheesecake topped with fresh strawberries and glaze.",
    image: "/images/416.png",
    category: "desserts",
    prepTime: 25,
    cookTime: 60,
    servings: 8,
    difficulty: "Medium",
    ingredients: [
      "1 1/2 cups graham cracker crumbs",
      "1/4 cup melted butter",
      "3 packages cream cheese, softened",
      "1 cup granulated sugar",
      "3 eggs",
      "1 tsp vanilla extract",
      "1 cup sour cream",
      "2 cups fresh strawberries",
      "1/4 cup strawberry glaze"
    ],
    instructions: [
      "Preheat oven to 325°F (160°C).",
      "Combine crumbs and butter, press into a springform pan.",
      "Beat cream cheese and sugar until smooth, add eggs one at a time.",
      "Stir in vanilla and sour cream, pour over crust.",
      "Bake for 60 minutes, then cool completely.",
      "Top with strawberries and glaze before serving."
    ],
    featured: true,
    popular: true
  },
  {
    id: 14,
    title: "Classic Tiramisu",
    description: "A no-bake Italian dessert with layers of coffee-soaked ladyfingers and mascarpone cream.",
    image: "/images/417.png",
    category: "desserts",
    prepTime: 30,
    cookTime: 0,
    servings: 6,
    difficulty: "Medium",
    ingredients: [
      "6 oz ladyfinger biscuits",
      "1 cup strong brewed coffee",
      "3 tbsp coffee liqueur (optional)",
      "3 large eggs, separated",
      "1/2 cup sugar",
      "1 cup mascarpone cheese",
      "1 cup heavy cream",
      "Cocoa powder for dusting"
    ],
    instructions: [
      "Combine coffee and liqueur in a shallow dish.",
      "Whisk egg yolks with sugar until creamy. Add mascarpone and mix.",
      "In another bowl, beat egg whites to stiff peaks.",
      "Whip cream separately. Fold everything together.",
      "Dip ladyfingers in coffee and layer with cream.",
      "Repeat and finish with cream. Chill 4+ hours.",
      "Dust with cocoa before serving."
    ],
    featured: true,
    popular: true
  },
  {
    id: 4,
    title: "Chocolate Chip Cookies",
    description: "Soft and chewy chocolate chip cookies that are perfect for any occasion.",
    image: "/images/402.png",
    category: "desserts",
    prepTime: 15,
    cookTime: 12,
    servings: 24,
    difficulty: "Easy",
    ingredients: [
      "1 cup unsalted butter, softened",
      "3/4 cup granulated sugar",
      "3/4 cup packed brown sugar",
      "2 large eggs",
      "2 tsp vanilla extract",
      "2 1/4 cups all-purpose flour",
      "1 tsp baking soda",
      "1/2 tsp salt",
      "2 cups semi-sweet chocolate chips"
    ],
    instructions: [
      "Preheat oven to 375°F (190°C). Line baking sheets with parchment paper.",
      "In a large bowl, cream together butter and both sugars until light and fluffy.",
      "Beat in eggs one at a time, then stir in vanilla.",
      "In a separate bowl, combine flour, baking soda, and salt.",
      "Gradually blend the dry ingredients into the wet mixture.",
      "Fold in chocolate chips.",
      "Drop by rounded tablespoons onto the prepared baking sheets, about 2 inches apart.",
      "Bake for 9-11 minutes or until golden brown around the edges.",
      "Allow cookies to cool on the baking sheet for 5 minutes before transferring to a wire rack."
    ],
    featured: true,
    popular: false
  },
  {
    id: 16,
    title: "Banana Bread",
    description: "Moist and flavorful banana bread with hints of cinnamon and vanilla.",
    image: "/images/419.png",
    category: "desserts",
    prepTime: 10,
    cookTime: 55,
    servings: 8,
    difficulty: "Easy",
    ingredients: [
      "3 ripe bananas, mashed",
      "1/2 cup melted butter",
      "3/4 cup sugar",
      "1 egg",
      "1 tsp vanilla extract",
      "1 tsp baking soda",
      "1 1/2 cups all-purpose flour",
      "1/2 tsp cinnamon",
      "Pinch of salt"
    ],
    instructions: [
      "Preheat oven to 350°F (175°C).",
      "In a bowl, mix mashed bananas and butter.",
      "Add sugar, egg, vanilla, and mix.",
      "Stir in baking soda, salt, cinnamon, and flour.",
      "Pour into greased loaf pan.",
      "Bake for 50–60 minutes. Let cool before slicing."
    ],
    featured: false,
    popular: true
  },
  {
    id: 17,
    title: "Lemon Bars",
    description: "Tangy and sweet lemon bars with a buttery shortbread crust.",
    image: "/images/420.png",
    category: "desserts",
    prepTime: 20,
    cookTime: 35,
    servings: 16,
    difficulty: "Medium",
    ingredients: [
      "1 cup butter, softened",
      "1/2 cup powdered sugar",
      "2 cups all-purpose flour",
      "4 large eggs",
      "1 1/2 cups granulated sugar",
      "1/4 cup flour",
      "1/2 cup lemon juice",
      "Zest from 1 lemon",
      "Powdered sugar for topping"
    ],
    instructions: [
      "Preheat oven to 350°F (175°C).",
      "Mix butter, powdered sugar, and flour. Press into baking pan.",
      "Bake crust 15–20 mins.",
      "Whisk eggs, sugar, flour, lemon juice, and zest.",
      "Pour over crust, bake 20–25 mins.",
      "Cool, then dust with powdered sugar before cutting."
    ],
    featured: false,
    popular: true
  },
  {
    id: 18,
    title: "Vanilla Panna Cotta",
    description: "A creamy Italian dessert made with vanilla bean and served chilled.",
    image: "/images/421.png",
    category: "desserts",
    prepTime: 15,
    cookTime: 5,
    servings: 4,
    difficulty: "Easy",
    ingredients: [
      "2 cups heavy cream",
      "1/2 cup whole milk",
      "1/2 cup sugar",
      "1 vanilla bean (or 1 tsp extract)",
      "2 1/2 tsp unflavored gelatin",
      "3 tbsp cold water",
      "Fresh berries for topping"
    ],
    instructions: [
      "Sprinkle gelatin over cold water and let bloom.",
      "Heat cream, milk, sugar, and vanilla until hot (not boiling).",
      "Remove from heat, stir in gelatin until dissolved.",
      "Pour into ramekins. Chill at least 4 hours.",
      "Serve with fresh berries."
    ],
    featured: true,
    popular: true
  }  
];